// AppOverlayContentView moved into Views/App/OverlayContentView.tsx. This thin re-export
// barrel keeps the original `./AppOverlayContentView` import path working for the many
// hub-external importers (menu components, AboutView, ShipSyncStatusView, ShipSelectView,
// the Account settings views) that import it outside the AppView hub.

export { AppOverlayContentView, AppOverlayContent, AppOverlayContentViewData } from "./App/OverlayContentView"
export type { AppOverlayContentOptions } from "./App/OverlayContentView"
